// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"237":"d30999b3","453":"50ba56e4","677":"c3d18d6f","697":"57dc1373","921":"6c0dc8c8","958":"886ef4c0","977":"63b891b8"}[chunkId] + ".chunk.js";
};